import { ReactComponent as Activate } from 'assets/svg/Activate.svg';
import { ReactComponent as Embed } from 'assets/svg/Embed.svg';
import { ReactComponent as Install } from 'assets/svg/Install.svg';
import React from 'react';
import { classNames } from 'util/Funcs';

const StepDescription = ({ step, children }: { step: string; children: React.ReactNode }) => (
    <span className="ml-4 flex min-w-0 flex-col">
        <span className="text-sm font-bold mt-2">{step}</span>
        {children}
    </span>
);

const InstallStepContent = () => (
    <>
        <p className="mt-5">
            Search for
            <span className="font-bold"> "hello:data" </span>
            in the WordPress plugin repository and click
            <span className="font-bold"> "Install Now." </span>
        </p>
        <p className="mt-5">
            Alternatively, You can download the plugin file here and upload it via the
            <span className="font-bold"> "Upload Plugin" </span>
            <br />
            option in your WordPress admin area.
        </p>
        <p className="mt-5">
            Once installed, click <span className="font-bold">"Activate Plugin"</span>
        </p>
    </>
);

const ActivateStepContent = () => (
    <>
        <p className="mt-5">
            In your WordPress dashboard, go to
            <span className="font-bold"> "Settings" &gt; "hello:data Search"</span>
        </p>
        <p className="mt-5">Enter your unique hello:data API Key in the provided field.</p>
        <p className="mt-5">
            Click
            <span className="font-bold"> "Save Changes" </span>
            to connect the plugin to your hello:data account.
        </p>
    </>
);

const EmbedStepContent = () => (
    <>
        <p className="mt-5">
            Copy the provided shortcode
            <span className="font-bold"> (e.g., [hello_data_search])</span>.
        </p>
        <p className="mt-5">Paste the shortcode into any page, post, or widget area where you want the search bar to appear.</p>
    </>
);

const steps = [
    {
        name: 'Install the Plugin',
        description: <InstallStepContent />,
        status: 'complete',
        icon: <Install />,
    },
    {
        name: 'Activate and Configure',
        description: <ActivateStepContent />,
        status: 'complete',
        icon: <Activate />,
    },
    {
        name: 'Embed the Search Bar',
        description: <EmbedStepContent />,
        status: 'complete',
        icon: <Embed />,
    },
];

const ProgressStep = ({ step, isLast }: { step: (typeof steps)[0]; isLast: boolean }) => (
    <li className={classNames(!isLast ? 'pb-10' : '', 'relative')}>
        <>
            {!isLast && <div aria-hidden="true" className="absolute left-4 top-10 -ml-px bottom-20 h-36 mt-1 w-0.5 bg-blue-300" />}
            <div className="group relative flex items-start">
                <span>{step.icon}</span>
                <StepDescription step={step.name}>{step.description}</StepDescription>
            </div>
        </>
    </li>
);

const ProgressBar = () => (
    <nav aria-label="Progress">
        <ol role="list" className="overflow-hidden">
            {steps.map((step, index) => (
                <ProgressStep key={step.name} step={step} isLast={index === steps.length - 1} />
            ))}
        </ol>
    </nav>
);

export default ProgressBar;
